import request from '@/utils/request'

let PsinApi = {

  list(data, errorback) {
    return request._post('/shop/plus.psin.Index/list', data, errorback);
  },
  skuStock(data, errorback) {
    return request._post('/shop/plus.psin.SkuStock/skuStock', data, errorback);
  },
  saveSetting(data, errorback) {
    return request._post('/shop/plus.psin.Setting/getSetting', data, errorback);
  },
  getSetting(data, errorback) {
    return request._get('/shop/plus.psin.Setting/getSetting', data, errorback);
  },
  syncProduct(data, errorback) {
    return request._get('/shop/plus.psin.Index/syncProduct', data, errorback);
  },
  detail(data, errorback) {
    return request._get('/shop/plus.psin.Index/detail', data, errorback);
  },
  edit(data, errorback) {
    return request._get('/shop/plus.psin.Index/edit', data, errorback);
  },
}
export default PsinApi;



// WEBPACK FOOTER //
// ./src/api/psin.js